
import type {
  BaseErrorResponse,
  EmptySuccessResponse,
  GetWalletTypeRes,
  GetWalletTypesRes,
  SetWalletTypeReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useWalletType() {
  class WalletType<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Wallet type
     * @name WalletTypeControllerGetWallets
     * @summary Get a list of wallet types
     * @request GET:/api3/wallet-type
     * @secure
     * @response `200` `GetWalletTypesRes`
     * @response `400` `BaseErrorResponse`
     */
    walletTypeControllerGetWallets = (
      query?: {
        /** @example false */
        includeInactive?: boolean;
        /**
         * Include currencies and rates
         * @example false
         */
        includeRates?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetWalletTypesRes, BaseErrorResponse>({
        path: '/api3/wallet-type',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Wallet type
     * @name WalletTypeControllerCreateWallet
     * @summary Create wallet
     * @request POST:/api3/wallet-type
     * @secure
     * @response `200` `GetWalletTypeRes`
     * @response `400` `BaseErrorResponse`
     */
    walletTypeControllerCreateWallet = (data: SetWalletTypeReq, params: RequestParams = {}) =>
      this.request<GetWalletTypeRes, BaseErrorResponse>({
        path: '/api3/wallet-type',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Wallet type
     * @name WalletTypeControllerUpdateWallet
     * @summary Update wallet
     * @request PUT:/api3/wallet-type/{walletId}
     * @secure
     * @response `200` `GetWalletTypeRes`
     * @response `400` `BaseErrorResponse`
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    walletTypeControllerUpdateWallet = (walletId: any, data: SetWalletTypeReq, params: RequestParams = {}) =>
      this.request<GetWalletTypeRes, BaseErrorResponse>({
        path: `/api3/wallet-type/${walletId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Wallet type
     * @name WalletTypeControllerDeleteWallet
     * @summary Delete wallet
     * @request DELETE:/api3/wallet-type/{walletId}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    walletTypeControllerDeleteWallet = (walletId: any, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/wallet-type/${walletId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new WalletType();
}
